module.exports = __webpack_public_path__ + "img/pic21.897f7004.jpg";